var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"dashboard-section-title"},[(_vm.icon)?_c('i',{class:("fa" + _vm.iconType + " fa-" + _vm.icon)}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }